var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "chevron-up_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "chevron-up_svg__chevron-up"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.29 8.71 6.7 13.3a.996.996 0 1 0 1.41 1.41L12 10.83l3.88 3.88a.996.996 0 1 0 1.41-1.41L12.7 8.71a.996.996 0 0 0-1.41 0",
    className: "chevron-up_svg__vector"
  }))));
};
export { SvgChevronUp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIiByb2xlPSJpbWciPjx0aXRsZT5DaGV2cm9uIFVwPC90aXRsZT48ZyBjbGFzcz0iY2hldnJvbi11cCI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNMTEuMjkgOC43MSA2LjcgMTMuM2EuOTk2Ljk5NiAwIDEgMCAxLjQxIDEuNDFMMTIgMTAuODNsMy44OCAzLjg4YS45OTYuOTk2IDAgMSAwIDEuNDEtMS40MUwxMi43IDguNzFhLjk5Ni45OTYgMCAwIDAtMS40MSAwWiIgY2xhc3M9InZlY3RvciIvPjwvZz48L3N2Zz4=";